export default "__VITE_ASSET__D$OY7$Cl__"